import { useState } from "react";
import { Form } from "../../Components/form";
import { useGlobalContext } from "../../Context/GlobalContext";
import { useNavigationContext } from "../../Context/NavigationContext";
import Notify from "../../Utils/Notify";
import { Logo } from "../../Components/logo";

const Login = () => {
  const { dbManager } = useGlobalContext();
  const { changeLandingView } = useNavigationContext();

  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const removeDataAttributes = (element: any) => {
    for (let attr of element.attributes) {
      if (attr.name.startsWith('data-')) {
        element.removeAttribute(attr.name);
      }
    }
  };

  // Monitor changes and remove data attributes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName?.startsWith('data-')) {
        if (mutation.attributeName) {
          (mutation.target as Element).removeAttribute(mutation.attributeName);
        }
      }
    });
  });

  // Apply to specific inputs
  document.querySelectorAll("input").forEach((input) => {
    removeDataAttributes(input); // Remove on page load
    observer.observe(input, { attributes: true }); // Watch for new attributes
  });

  const handleLogin = async (user?: string, pass?: string) => {
    setLoading(true);
    if(await dbManager.auth(user ?? username, pass ?? password)) {
      changeLandingView('terminal');
    } else {
      Notify('error', 'Login failed');
      setLoading(false);
    }
  }

  return (
    <div className="login" style={{width: '40%', margin: 'auto', marginTop: '3vh'}}>
      <Logo />
      <div className="form-container">
        <Form
          fields={[
            {
              label: "EMAIL",
              type: "email",
              placeholder: "hello@neo.com",
              setValue: setUsername,
              value: username,
              name: "username",
            },
            {
              label: "PASSWORD",
              type: "password",
              placeholder: "******",
              setValue: setPassword,
              value: password,
              forgotPassword: true,
              name: "password",
            },
          ]}
          submit={handleLogin}
          buttonText="LOGIN"
          loading={loading}
        />
      </div>
      <div className="login-footer knog-font">
        Don't have an account? 
        <span className="sign-up" onClick={() => changeLandingView('register')}>
          Sign up
        </span>
      </div>
    </div>
  );
}

export default Login;